const jakartaFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Asia/Jakarta',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

export function jakartaDate(date = new Date()): string {
  const parts = Object.fromEntries(jakartaFormatter.formatToParts(date).map((part) => [part.type, part.value]))
  return `${parts.year}-${parts.month}-${parts.day}`
}

export function startOfLastMonths(months: number, date = new Date()): string {
  if (!Number.isInteger(months) || months < 1) throw new Error('Jumlah bulan harus positif')
  const firstDay = new Date(`${jakartaDate(date).slice(0, 7)}-01T00:00:00Z`)
  firstDay.setUTCMonth(firstDay.getUTCMonth() - months + 1)
  return firstDay.toISOString().slice(0, 10)
}

export function jakartaGreeting(date = new Date()): string {
  const hour = Number(new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Jakarta', hour: '2-digit', hourCycle: 'h23' }).format(date))
  if (hour < 11) return 'Selamat pagi'
  if (hour < 15) return 'Selamat siang'
  if (hour < 18) return 'Selamat sore'
  return 'Selamat malam'
}
